import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

// Configure Supabase client with auth options
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

// Force refresh session to get new tokens
export const forceRefreshSession = async () => {
  const { error } = await supabase.auth.refreshSession();
  if (error) {
    console.error('Error refreshing session:', error);
    return false;
  }
  console.log('Session refreshed successfully');
  return true;
}; 